export const VALID_PAGES = ["poland", "argentina"];
export const MAX_NAV_WIDTH_MOBILE = 1090;